"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButtonIconOnly = void 0;

var _styledTools = require("styled-tools");

var _stylitas = require("@creditas/stylitas");

var noShadow = (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:hover {\n    box-shadow: none;\n  }\n"])));

var baseStyles = function baseStyles(props) {
  return (0, _stylitas.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: none;\n  background-color: ", ";\n  font-weight: 500;\n  transition: box-shadow 0.3s;\n  outline: none;\n  cursor: pointer;\n\n  &:hover {\n    box-shadow: 0px 16px 8px -12px rgba(0, 0, 0, 0.12),\n      0px 16px 12px -8px rgba(0, 0, 0, 0.16);\n  }\n\n  &:disabled {\n    background-color: ", ";\n  }\n\n  ", "\n"])), (0, _styledTools.prop)('theme.colorButtonPrimaryLight')(props), (0, _styledTools.prop)('theme.colorNeutral10')(props), (0, _styledTools.ifProp)('disabled', noShadow)(props));
};

var sizes = (0, _styledTools.switchProp)('size', {
  medium: (0, _stylitas.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-size: 16px;\n    padding: 10px;\n    border-radius: 10px;\n  "]))),
  large: (0, _stylitas.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 32px;\n    padding: 14px;\n    border-radius: 16px;\n    & > svg {\n      width: 32px;\n      heigth: 32px;\n    }\n  "])))
});

var StyledButtonIconOnly = _stylitas.styled.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), baseStyles, sizes);

exports.StyledButtonIconOnly = StyledButtonIconOnly;